import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ArrowRightLeft } from "lucide-react";

const INPUT_STYLE = { background: "var(--vault-bg)", border: "1px solid var(--vault-border)" };

export default function OwnerTransferForm({ code, onDone, onCancel }) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [note, setNote] = useState("");
  const [notify, setNotify] = useState(true);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!window.confirm(`Transfer bottle ${code.code} to ${email.trim()}? The current owner loses access immediately.`)) return;
    setSaving(true);
    try {
      await api.post(`/admin/codes/${code.id}/transfer`, { owner_email: email.trim(), owner_phone: phone.trim() || null, note: note.trim() || null, notify });
      toast.success("Ownership transferred");
      onDone?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Transfer failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3 rounded-lg p-4 fade-up" style={{ background: "rgba(197,160,89,0.06)", border: "1px solid rgba(197,160,89,0.25)" }} data-testid="transfer-form">
      <p className="overline text-[var(--vault-gold)] inline-flex items-center gap-1.5"><ArrowRightLeft className="w-3 h-3" /> Transfer to a new owner</p>
      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="New owner email" className="w-full px-3 py-2.5 rounded outline-none text-sm" style={INPUT_STYLE} data-testid="transfer-email-input" />
      <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="New owner phone (optional)" className="w-full px-3 py-2.5 rounded outline-none text-sm" style={INPUT_STYLE} data-testid="transfer-phone-input" />
      <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (e.g. sold at auction, invoice #123)" maxLength={300} className="w-full px-3 py-2.5 rounded outline-none text-sm" style={INPUT_STYLE} data-testid="transfer-note-input" />
      <label className="flex items-center gap-2 text-xs text-[var(--vault-text-muted)] cursor-pointer">
        <input type="checkbox" checked={notify} onChange={(e) => setNotify(e.target.checked)} className="accent-[var(--vault-gold)]" data-testid="transfer-notify-checkbox" />
        Email the new owner (welcome) and the previous owner (access ended)
      </label>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={onCancel} className="btn-ghost px-4 py-2 rounded-md text-sm" data-testid="transfer-cancel-btn">Cancel</button>
        <button type="submit" disabled={saving || !email.trim()} className="btn-gold px-5 py-2 rounded-md text-sm" data-testid="transfer-submit-btn">
          {saving ? <span className="spin" /> : "Transfer ownership"}
        </button>
      </div>
    </form>
  );
}
